// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide[data-v-60da9de8]{height:auto}[data-v-60da9de8] .logo-img img{object-position:left!important}@media (max-width:580px){.logo-img img[data-v-60da9de8]{height:50px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
